import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Usługi',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Taras dostępny',
    [STORE_SERVICES.DINE_IN]: 'Na miejscu',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Zamówienia online przez FoodAmigos',
    [STORE_SERVICES.RESERVATION]: 'Rezerwacje przez FoodAmigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Rezerwacje w restauracji',
  },
  labels: {
    reservation_total_seats: 'Łączna liczba miejsc',
    catering_min_people: 'Catering min. osób',
  },
};
